package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.animation.animateColorAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.windowInsetsTopHeight
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Sets the platform status-bar icon appearance. [lightIcons] = light (white) icons for a dark
 * band behind the status bar; false = dark icons for light content. Implemented on Android via
 * the window insets controller; a no-op on iOS/web (managed by the platform shell there).
 * The Android actual restores dark icons when the caller leaves composition, so a screen that
 * sets light icons can never leak them to the next screen.
 */
@Composable
expect fun PlatformStatusBarAppearance(lightIcons: Boolean)

/**
 * Scroll-reactive status-bar scrim for screens whose colored header band draws BEHIND the status
 * bar (e.g. Home): transparent while the band is under the status bar (band color + light icons
 * show through), animating to [AppTheme.colors.surface] with dark icons once content scrolls
 * underneath. Place as a top-aligned overlay ABOVE the scrolling content.
 */
@Composable
fun StatusBarScrim(scrolled: Boolean, modifier: Modifier = Modifier) {
    val color by animateColorAsState(
        if (scrolled) AppTheme.colors.surface else Color.Transparent,
    )
    androidx.compose.foundation.layout.Box(
        modifier = modifier
            .fillMaxWidth()
            .windowInsetsTopHeight(WindowInsets.statusBars)
            .background(color),
    )
    PlatformStatusBarAppearance(lightIcons = !scrolled)
}
